import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import color from 'style/colors';
import fonts from 'style/fonts';
import { mq } from 'style/variables';
import sizes from 'style/sizes';

type DataNumberProps = {
  title: string;
  number: string;
  isPlus?: boolean;
  isMinus?: boolean;
  unit?: string;
};

const Container = styled.div``;

const Title = styled.div`
  margin-bottom: ${sizes.margin[17]};
  font-family: ${fonts.enGothic};
  font-weight: 600;
  letter-spacing: 0.1em;
  font-size: 16px;
  margin-bottom: 8px;
  line-height: 1;
`;

const Inner = styled.div`
  position: relative;
  display: flex;
  align-items: baseline;
  font-family: ${fonts.jaGothic};
  line-height: 1;
  ${mq.onlysp} {
    width: 100%;
    flex-wrap: wrap;
  }
  ${props =>
    (props.isPlus || props.isMinus) &&
    css`
      position: relative;
      padding-left: 22px;
      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 93px;
        left: 0;
        width: 21px;
        height: 1px;
        background-color: ${color.black01};
        ${mq.onlysp} {
          top: 74px;
        }
      }
    `}
  ${props =>
    props.isPlus &&
    css`
      &::after {
        content: '';
        display: block;
        position: absolute;
        top: 83px;
        left: 10px;
        width: 1px;
        height: 21px;
        background-color: ${color.black01};
        ${mq.onlysp} {
          top: 64px;
        }
      }
    `}
`;

const Number = styled.div`
  font-family: ${fonts.enGothic};
  font-size: 120px;
  white-space: nowrap;
  margin-right: ${sizes.margin[17]};
  font-weight: 600;
  ${mq.onlypc} {
    font-size: 96px;
  }
`;

const Unit = styled.div`
  font-size: 40px;
  white-space: nowrap;
  ${mq.onlysp} {
    font-size: 32px;
  }
`;

export const DataNumber: React.FC<DataNumberProps> = props => {
  return (
    <Container>
      <Title>{props.title}</Title>
      <Inner {...props}>
        <Number {...props}>{props.number}</Number>
        {props.unit && <Unit>{props.unit}</Unit>}
      </Inner>
    </Container>
  );
};
